import type { Adventure } from '../../types'

// Subtraction Sea - Age 5 - Underwater subtraction theme
export const tillySeaCorrect = [
  "Splashing! That's correct!",
  "Bubbles! You got it!",
  "Swimming success! Well done!",
  "Sea-riffic subtraction!",
  "Ocean awesome! Perfect!",
  "Fin-tastic! You know it!",
  "Waving great job! Correct!",
  "Coral reef clever! You got it!",
  "Tide is right! That is it!",
  "Deep sea smart! Amazing!"
]

export const tillySeaWrong = [
  "Oh no, lost a bubble! Try again!",
  "Swim back and try once more!",
  "Almost caught it! Give it another go!",
  "Do not sink! Count again!",
  "Keep swimming! You will get it!",
  "Blow some bubbles and try again!",
  "Current is strong! Try once more!",
  "Not quite! Count the fish!",
  "Keep diving! You will find it!",
  "Splash! Try again!"
]

export const subtractionSeaAdventure: Adventure = {
  id: 'subtraction-sea',
  title: 'Subtraction Sea',
  theme: 'addition',
  targetAge: '5',
  difficulty: 'medium',
  estimatedDuration: 10,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello underwater explorer! I am Tilly! Let us dive into subtraction with our ocean friends!",
      duration: 4
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look! 8 fish swimming! 3 fish swam away. How many fish are left? Let's count the remaining fish!",
      duration: 5
    },
    choice1: [
      {
        id: 'fish',
        label: 'Count fish!',
        tillyLine: "Fish friends!",
        nextState: 'quiz-1'
      },
      {
        id: 'shells',
        label: 'Collect shells!',
        tillyLine: "Shells by the seashore!",
        nextState: 'story-2'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'simple-addition',
      question: '10 bubbles float up! 4 pop!',
      tillyPrompt: '10 minus 4 equals?',
      options: [
        { id: 'five', label: '5', isCorrect: false },
        { id: 'six', label: '6', isCorrect: true },
        { id: 'seven', label: '7', isCorrect: false }
      ],
      num1: 10,
      num2: -4
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Bubbling great! Now let us find shells! We collected 12 shells but gave 5 to a friend!",
      duration: 4
    },
    choice2: [
      {
        id: 'pearls',
        label: 'Find pearls!',
        tillyLine: "Shiny pearls!",
        nextState: 'quiz-2'
      },
      {
        id: 'crabs',
        label: 'Count crabs!',
        tillyLine: "Pinchy crabs!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'simple-addition',
      question: '12 starfish on the beach! 5 crawl away!',
      tillyPrompt: '12 minus 5 equals?',
      options: [
        { id: 'six', label: '6', isCorrect: false },
        { id: 'seven', label: '7', isCorrect: true },
        { id: 'eight', label: '8', isCorrect: false }
      ],
      num1: 12,
      num2: -5
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "Ocean math master! Challenge Round: Deep sea subtraction with bigger numbers!",
        duration: 4
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'simple-addition',
          question: '15 jellyfish floating! 7 swim away!',
          tillyPrompt: '15 minus 7 equals?',
          options: [
            { id: 'seven', label: '7', isCorrect: false },
            { id: 'eight', label: '8', isCorrect: true },
            { id: 'nine', label: '9', isCorrect: false }
          ],
          num1: 15,
          num2: -7
        } as any,
        {
          id: 'challenge-2',
          type: 'simple-addition',
          question: '18 seashells! You give 9 to the octopus!',
          tillyPrompt: '18 minus 9 equals?',
          options: [
            { id: 'eight', label: '8', isCorrect: false },
            { id: 'nine', label: '9', isCorrect: true },
            { id: 'ten', label: '10', isCorrect: false }
          ],
          num1: 18,
          num2: -9
        } as any,
        {
          id: 'challenge-3',
          type: 'simple-addition',
          question: '20 fish! A whale eats 8!',
          tillyPrompt: '20 minus 8 equals?',
          options: [
            { id: 'eleven', label: '11', isCorrect: false },
            { id: 'twelve', label: '12', isCorrect: true },
            { id: 'thirteen', label: '13', isCorrect: false }
          ],
          num1: 20,
          num2: -8
        } as any
      ]
    },
    reward: {
      tillyLine: "Ocean-riffic! You mastered deep sea subtraction! You are a Subtraction Sea Champion!",
      badgeName: 'Sea Explorer',
      badgeIcon: '🐙',
      nextPreview: 'Next time, we will stack more shapes!'
    }
  }
}
